import { render, staticRenderFns } from "./TopPlacementFinancials.vue?vue&type=template&id=84416f06&scoped=true&"
import script from "./TopPlacementFinancials.vue?vue&type=script&lang=js&"
export * from "./TopPlacementFinancials.vue?vue&type=script&lang=js&"
import style0 from "./TopPlacementFinancials.vue?vue&type=style&index=0&id=84416f06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84416f06",
  null
  
)

export default component.exports